import { Text } from 'react-native'
import { ScreenLoadingFallback } from '@/src/components/ui/ScreenLoadingFallback'
import { useTranslation } from 'react-i18next'

export default function CallbackScreen() {
  const { t } = useTranslation(['common'])

  return (
    <ScreenLoadingFallback>
      <Text className="mt-4 text-center text-ink text-base">
        {t('common:callback_completing_sign_in')}
      </Text>
    </ScreenLoadingFallback>
  )
}
